var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ChevronUpIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 65,
    glyphHeight: 39,
    glyphOffsetY: -4
  }), React.createElement("path", {
    d: "M64.0346 32.1992L57.5941 38.708L32.035 13.1558L6.59164 38.8459L0.138897 32.3719L31.9999 0.173266L64.0346 32.1992Z"
  }));
};
export var ChevronUpIconGlyph = function (props) {
  return React.createElement(ChevronUpIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};